import React from 'react';
import ScopedNumbersTab from './ScopedNumbersTab';
import { CADENCE_CONFIG } from '../constants';

const CadenceTab: React.FC = () => <ScopedNumbersTab config={CADENCE_CONFIG} />;

export default CadenceTab;
